import { memo } from "react";

const LogoSk = memo(() => {
  return (
    <span className={"w-64 md:w-72 h-20 md:h-20 bg-gray-500 rounded-md"} />
  );
});

export default LogoSk;
